import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import * as siRoutes from "app/pages/sales-intelligence/constants/routes";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { isContactNameHidden } from "app/pages/sales-intelligence/sub-modules/contacts-search/utils/isContactNameHidden";
import { proNavigator } from "single-spa/react-app/ProNavigator";

interface IProps {
    domain: string;
    recipient?: string;
    onClick?: VoidFunction;
}

const CraftEmailDropdownItem = ({ domain, recipient, onClick }: IProps): ReactElement => {
    const isDisabled = !salesSettingsHelper.isAiCraftEmailAgentEnabled;

    const agentLink = proNavigator.href(siRoutes.AI_AGENT_EMAIL, {
        domain,
        recipient: !recipient || isContactNameHidden(recipient) ? undefined : recipient,
        autogenerate: true,
    });

    const dropdownItem = (
        <ExportVariantsDropdownItem
            iconName="craft-email"
            isDisabled={isDisabled}
            iconColor={colorsPalettes.carbon[200]}
            text={translate("si.company-analysis.company.ai-agent.email.button")}
            variant="meeting"
            onClick={onClick}
        />
    );

    if (!isDisabled) {
        return (
            <a
                href={agentLink}
                target="_blank"
            >
                {dropdownItem}
            </a>
        );
    }

    return dropdownItem;
};

export default CraftEmailDropdownItem;
